import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { stripClientPrefix } from '../utils/modulesNavigation';

/**
 * Hook to extract the current usecase slug (DP-3570) from the URL path.
 * Works for usecase routes like:
 * - /clientId/:clientId/entities/:entityName/uc/:usecase
 * - /clientId/:clientId/entities/:entityName/uc/:usecase/:entityId
 *
 * Non-usecase entity routes (`/entities/:entityName`, `/entities/:entityName/:entityId`)
 * have no `/uc/` marker and return `undefined`, which keeps every metadata read
 * on the default (usecase-absent) path.
 *
 * @returns The usecase slug from the URL, or `undefined` when not on a usecase route.
 */
export function useCurrentUsecase(): string | undefined {
  const { pathname } = useLocation();

  return useMemo(() => {
    const pathWithoutClient = stripClientPrefix(pathname);
    const regex = /^\/entities\/[^/]+\/uc\/([^/]+)/;
    const match = regex.exec(pathWithoutClient);
    return match?.[1];
  }, [pathname]);
}
